import axios from "axios";
import { BACKEND_URL } from "./Constants";
import { getLatestConfigQuery } from "./queries";
import { addUserAcknowledgementMutation } from "./mutations";

export const getLatestConfig = async () => {
    const response = await axios.post(
      BACKEND_URL,
      getLatestConfigQuery()
    );
    return response.data;
};

export const addUserAcknowledgement = async (token, ackType, version, remark = "") => {
    const response = await axios.post(
      BACKEND_URL,
      addUserAcknowledgementMutation(token, ackType, version, remark),
      {timeout: 2000}
    );
    return response.data;
};
  